import { getRequest } from '../services/requestHandler';
import { PutterSightLineForSaveDto } from '../models';

export const getPutterSightlines = async () => {
  const url = 'putter/getPutterSightlines?activeOnly=true&useCache=false';
  const response = await getRequest<PutterSightLineForSaveDto>('GetPutterSightlines', url);
  return response;
};
